$(".sca-storepickup-delivery-tab").on("click", function() {
    console.log("clicked");
    // $("#deliveryRoutePopup").show();
});

let popup = document.getElementById("deliveryRoutePopup");

function showPopup() {
    // if (popup.style.display === "none" || popup.style.display === "") {
    popup.style.display = "block"; // Show the div
    // } else {
    //     popup.style.display = "none"; // Hide the div
    // }
}

function hidePopup() {
    popup.style.display = "none";
}

// $(window).ready(function() {
//     console.log("jQuery Working");
// });
// let productId = "8840529707261";
// let variantId = "46115349856509";
// let loaderId = document.getElementById("cartLoader");
// let cartStyleForCharges = `
//     tr.cart-item:first-of-type quantity-input,
//     tr.cart-item:first-of-type cart-remove-button {
//         display: none;
//     }
// `;
// let cartStyleForCharges2 = `
//     tr.cart-item:first-of-type quantity-input{
//         display: none;
//     }
// `;

// function deliveryCharges() {
//     loaderId.style.display = "flex";
//     // Check if the product is already in the cart
//     fetch('/cart.js')
//         .then(response => response.json())
//         .then(cart => {
//             let item = cart.items.find(i => i.variant_id == variantId);
//             if (item) {
//                 // Product exists in the cart,
//                 console.log("Charges already in cart.");
//                 loaderId.style.display = "none";
//                 // removeFromCart(item.key);
//             } else {
//                 // Product not in cart, add it
//                 addToCart(variantId, loaderId);
//             }
//         });
// }

// function removeDeliveryCharges() {
//     loaderId.style.display = "flex";
//     // Check if the product is already in the cart
//     fetch('/cart.js')
//         .then(response => response.json())
//         .then(cart => {
//             let item = cart.items.find(i => i.variant_id == variantId);
//             if (item) {
//                 // Product exists in the cart,
//                 removeFromCart(item.key, loaderId);
//             } else {
//                 // Product not in cart, add it
//                 console.log("Charges not in cart.");
//                 loaderId.style.display = "none";
//             }
//         });
// }

// function removeDeliveryCharges2() {
//     loaderId.style.display = "flex";
//     // Check if the product is already in the cart
//     fetch('/cart.js')
//         .then(response => response.json())
//         .then(cart => {
//             let item = cart.items.find(i => i.variant_id == variantId);
//             if (item) {
//                 // Product exists in the cart,
//                 removeFromCart(item.key, loaderId);
//             } else {
//                 // Product not in cart, add it
//                 console.log("Charges not in cart.");
//                 loaderId.style.display = "none";
//             }
//         });
// }

// // Function to add product to cart
// function addToCart(productId, loader) {
//     fetch('/cart/add.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ id: productId, quantity: 1 })
//         })
//         .then(response => response.json())
//         .then(data => {
//             // alert("Product added to cart!");
//             let styleTag = document.createElement("style");
//             styleTag.id = "customCartStyle"; // Assign an ID to prevent duplicates
//             styleTag.innerHTML = cartStyleForCharges;
//             moveSpecialProductToTop();
//             // Remove existing style tag if it exists (to prevent duplicates)
//             let existingStyle = document.getElementById("customCartStyle");
//             if (existingStyle) {
//                 existingStyle.remove();
//             }

//             // Append new style tag to the <head>
//             document.head.appendChild(styleTag);
//             loader.style.display = "none";
//         })
//         .catch(error => {
//             loader.style.display = "none";
//             console.error("Error adding product:", error);
//         });
// }

// // Function to remove product from cart
// function removeFromCart(itemKey, loader) {
//     fetch('/cart/change.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({ id: itemKey, quantity: 0 })
//         })
//         .then(response => response.json())
//         .then(data => {
//             // alert("Product removed from cart!");
//             let existingStyle = document.getElementById("customCartStyle");
//             existingStyle.remove();
//             loader.style.display = "none";
//         })
//         .catch(error => {
//             loader.style.display = "none";
//             console.error("Error removing product:", error);
//         });
// }

// function moveSpecialProductToTop() {
//     let cartTable = document.querySelector(".cart-items"); // Target cart table
//     let cartRows = document.querySelectorAll(".cart-item"); // Get all cart rows

//     cartRows.forEach(row => {
//         let productLink = row.querySelector(".cart-item__details a");
//         if (productLink && productLink.href.includes("/products/charges-for-route-delivery-option")) {
//             console.log("Found special product, moving to top...");
//             cartTable.prepend(row); // Move this row to the top
//         }
//     });
// }

// function updateCartSubtotal() {
//     fetch('/cart.js')
//         .then(response => response.json())
//         .then(cart => {
//             let subtotal = cart.total_price / 100; // Shopify returns price in cents
//             let subtotalElement = document.querySelector('.cart-subtotal-price');
//             if (subtotalElement) {
//                 subtotalElement.textContent = `$${subtotal.toFixed(2)}`;
//             }
//         })
//         .catch(error => console.error("Error fetching cart data:", error));
// }


